import { render, staticRenderFns } from "./SlaReportHistory.vue?vue&type=template&id=479cf34e&scoped=true&"
import script from "./SlaReportHistory.vue?vue&type=script&lang=js&"
export * from "./SlaReportHistory.vue?vue&type=script&lang=js&"
import style0 from "./SlaReportHistory.vue?vue&type=style&index=0&id=479cf34e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479cf34e",
  null
  
)

export default component.exports